import { CCol, CContainer, CRow } from '@coreui/react-pro'
import React from 'react'
import '../DataTable/DataTable.scss'
import PropTypes from 'prop-types'
import { WHITE } from '../../../scss/colorConsts'

const CardIssues = ({ item }) => {
  return (
    <div className="issuescard-container mt-2">
      <CContainer>
        <CRow>
          <CCol sm="2" className="px-0">
            <div className="issuescard-icon-container m-0">
              <div className="warning-sign" style={{ color: WHITE }}>
                !
              </div>
            </div>
          </CCol>

          <CCol sm="10">
            <div className="issuescard-data-container">
              <span className="issuescard-heading">
                {item?.patient_lastname}, {item?.patient_firstname}
              </span>
              <span className="issuescard-subheading">{item?.facility_name}</span>
              {item?.reason_codes &&
                item?.reason_codes.length > 1 &&
                item?.reason_codes.map((reasons, index) => (
                  <span key={index} className="issuescard-description">
                    {reasons}
                  </span>
                ))}
              {item?.reason_codes && item?.reason_codes.length === 1 && (
                <span className="issuescard-description">{item?.reason_codes[0]}</span>
              )}
              {!item?.reason_codes && <span className="issuescard-description">-</span>}
            </div>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

CardIssues.propTypes = {
  item: PropTypes.any,
}

export default CardIssues
